import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { IAppState } from '../app.state';
import { requestCurrentOrganization } from '../organizations/organizations.actions';
import { getCurrentOrganization, selectShareOrganization } from '../organizations/organizations.selector';
import { filter, take } from 'rxjs/operators';
import { QueryService } from '../../query.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorResolverService {

  shareOrganization$: any;

  constructor(
    public _store: Store<IAppState>,
    private queryService: QueryService
  ) { }

  resolve() {    
    if (!this.queryService.isEmbed()) {
      this._store.dispatch(requestCurrentOrganization());
    }
    return this._store.pipe(select(getCurrentOrganization)).pipe(
        take(1),
        filter(currentOrg => currentOrg !== undefined),
      )
  }
}
